module.exports = __webpack_public_path__ + "img/kickbite-mini.97a3e430.svg";